import { Paper as MUIPaper, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomPaper = styled(MUIPaper)(({ variant, theme }) => {
    return {
        ...(variant === 'outlined' && {
            border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
            borderRadius: '8px',
            padding: theme.spacing(3, 4),
        }),
    };
});

const Paper = forwardRef((props, ref) => {
    return <CustomPaper ref={ref} {...props} />;
});

export default Paper;
